import { Box, Grid } from '@material-ui/core';
import React from 'react';
import { formatNumber } from '../../../../../logic/otherUtilities/formatting/formatNumber';
import { formatTemplate } from '../../../../../logic/otherUtilities/formatting/formatTemplate';
import { internationalText, Language } from '../../../internationalText';

export interface ItemProps {
  count: number;
  language: Language;
}

export const Item: React.FC<ItemProps> = ({ count, language }) => {
  if (!count) {
    return null;
  }
  return (
    <Grid item>
      <div className="pt-1 text-sm font-normal text-center italic">
        {formatTemplate(internationalText.chart.general.more[language], [formatNumber(count)])}
      </div>
    </Grid>
  );
};

export default Item;
